import { atom } from "recoil";

export const editPermissionsState = atom({
  key: "editPermissionsState",
  default: false,
});
